<script setup>
  import { ref, computed, watchEffect } from 'vue'
  const model = defineModel();

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    showTicks: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  });

  let timeline = ref(null);

  const styles = computed(() => ({
    '--current-value-position': `${model.value / props.max * 100}%`
  }))

  watchEffect(() => {
    if(timeline.value) {
      timeline.value.max = props.max;
      timeline.value.value = model.value;
    }
  });
</script>

<template>
  <div 
    class="jwx-slider-control"
    :style="styles"  
    >
    <input
      ref="timeline"
      type="range"
      class="jwx-slider-control__input"
      v-model="model"
      :name="props.id"
      :id="props.id"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      :disabled="props.disabled"
    />
    <div v-if="showTicks" class="jwx-slider-control__ticks"></div>
    <slot></slot>
  </div>
</template>